import { render, staticRenderFns } from "./information-text.vue?vue&type=template&id=d09d330c&"
import script from "./information-text.vue?vue&type=script&lang=js&"
export * from "./information-text.vue?vue&type=script&lang=js&"
import style0 from "./information-text.vue?vue&type=style&index=0&id=d09d330c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports